module.exports = __webpack_public_path__ + "img/currents-providers.0d0c54c.png";